import { render, staticRenderFns } from "./inspector.vue?vue&type=template&id=6a4a44d1&scoped=true&"
import script from "./inspector.vue?vue&type=script&lang=ts&"
export * from "./inspector.vue?vue&type=script&lang=ts&"
import style0 from "./inspector.vue?vue&type=style&index=0&id=6a4a44d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a44d1",
  null
  
)

export default component.exports